const excesoCabidaFileName = 'JustificanteLexnet'
const excesoCabidaSubTipo = 'EXCESO_DE_CABIDA'
const excesoCabidaSubTipoObject = {
  id: 296,
  codigo: 'EXC',
  descripcion: 'Exceso de cabida lexnet',
  tipoDocumento: {
    id: 113,
    codigo: '059'
  }
}

export { excesoCabidaFileName, excesoCabidaSubTipo, excesoCabidaSubTipoObject }
